<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">

    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card [options]="options" (reloadFunction)="reloadChangelog($event)">
              <ng-container mCardHeaderTitle>
                Bileşikler <a class="btn btn-primary" routerLink="/newcompound">+ Yeni Ekle</a>
              </ng-container>
              <ng-container mCardBody>
                <div class="row mb-2">
                 
                  <div class="col-md-12">
                    Bileşik Arama   <input type="text" class="form-control col-md-4" (change)="search($event)">
                  </div>
                </div>
               
                <table class="table table-bordered">
                  <thead>
                  <tr>
                    <th>Hammadde/Kimyasal (Ticari) Adı</th>
                    <th>INCI Adı</th>
                    <th>CAS</th>
                    <th>EINECS/ELICS</th>
                    <th>Fonksiyon</th>
                    <th>% HM</th>
                  
                    <th>İşlemler</th>
                  </tr>
                </thead>

                <ng-container *ngFor="let item of filteredhammeddeler">
                  <tr class="main-row">
                    <td class="align-middle" [attr.rowspan]="item.materials.length">{{ item.name }}</td>
                    <td>{{ item.materials[0].material.inciName }}</td>
                    <td>{{item.materials[0].material.cas}}</td>
                    <td>{{item.materials[0].material.einecs}}</td>
                    <td>{{item.materials[0].material.function}}</td>
                    <td>{{item.materials[0].hm}}</td>
                 
                    <td class="align-middle" [attr.rowspan]="item.materials.length">
                      <i class="la la-edit success" (click)="openEditModal(h)" style="cursor: pointer;"></i> |
                      <i class="la la-remove danger" (click)="delete(h.id)" style="cursor: pointer;"></i>
                    </td>
                  </tr>
                  <tr *ngFor="let cat of item.materials.slice(1)">
                    <td>{{ cat.material.inciName }}</td>
                    <td>{{cat.material.cas}}</td>
                    <td>{{cat.material.einecs}}</td>
                    <td>{{cat.material.function}}</td>
                    <td>{{cat.hm}}</td>
                   
                  
                  </tr>
                </ng-container>


                
                 
                </table>
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
